import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../../../../../_metronic/helpers'

interface Props {
    onNext: () => void
    activeTab: "NON_DIVERSION" | "DIVERSION"
    setActiveTab: (tab: "NON_DIVERSION" | "DIVERSION") => void
    processes: any[]
    isLoading: boolean
    error: string | null
    setSelectedProcess: (process: any) => void

}

const ProcessCards: React.FC<Props> = ({ onNext, activeTab, setActiveTab, processes, isLoading, error, setSelectedProcess, }) => {

    return (
        <div className='card card-flush h-xl-100'>
            {/* Header */}
            <div className='card-header pt-7'>
                <div className='card-title d-flex align-items-center'>
                    <button className='btn btn-icon btn-sm btn-active-light-primary me-3'>
                        <KTIcon iconName='arrow-left' className='fs-2' />
                    </button>
                    <h3 className='card-label fw-bolder text-dark fs-3 mb-0'>Select process</h3>
                </div>
                <div className='card-toolbar'>
                    <span className='text-success fw-bolder fs-4'>1</span>
                    <span className='text-dark fw-bold fs-6 ms-1'>of 3</span>
                </div>
            </div>

            <div className='card-body pt-5'>
                {/* Segmented Control / Tabs */}
                <div className='d-flex justify-content-center mb-10'>
                    <div className='bg-light rounded-pill p-1 d-inline-flex border border-secondary border-dashed' style={{ minWidth: "70%" }}>
                        <button
                            onClick={() => setActiveTab('NON_DIVERSION')}
                            className={`btn btn-sm rounded-pill flex-grow-1 py-3 px-6 fw-bolder fs-6 transition-all ${activeTab === 'NON_DIVERSION' ? 'btn-primary shadow-sm' : 'btn-active-light-primary text-gray-600'
                                }`}
                        >
                            Pre processing
                        </button>
                        <button
                            onClick={() => setActiveTab('DIVERSION')}
                            className={`btn btn-sm rounded-pill flex-grow-1 py-3 px-6 fw-bolder fs-6 transition-all ${activeTab === 'DIVERSION' ? 'btn-primary shadow-sm' : 'btn-active-light-primary text-gray-600'
                                }`}
                        >
                            Recycling
                        </button>
                    </div>
                </div>

                {isLoading ? (
                    <div className='d-flex justify-content-center align-items-center' style={{ height: '200px' }}>
                        <div className='spinner-border text-primary' role='status'>
                            <span className='visually-hidden'>Loading...</span>
                        </div>
                    </div>
                ) : error ? (
                    <div className='alert alert-danger d-flex align-items-center p-5 mb-10'>
                        <KTIcon iconName='shield-cross' className='fs-2hx text-danger me-4' />
                        <div className='d-flex flex-column'>
                            <h4 className='mb-1 text-danger'>Network Error</h4>
                            <span>{error}</span>
                        </div>
                    </div>
                ) : (
                    <div className='row g-6 g-xl-9'>
                        {processes
                            .filter(p => p.processType === activeTab)
                            .map((process: any) => (
                                <div key={process.id} className='col-md-3 col-xxl-2' onClick={() => {
                                    setSelectedProcess(process)
                                    onNext()
                                }}>
                                    <div className='card border border-gray-300 border-hover-primary h-100 cursor-pointer shadow-sm-hover transition-all'>
                                        <div className='card-body d-flex flex-column align-items-center justify-content-center p-9'>
                                            <div className='symbol symbol-100px symbol-circle mb-7 bg-light d-flex align-items-center justify-content-center overflow-hidden'>
                                                {process.icon && process.icon.includes('/') ? (
                                                    <img src={toAbsoluteUrl(process.icon)} alt={process.name} className='w-140px h-140px' style={{ objectFit: 'cover' }} />
                                                ) : (
                                                    <div className='bg-light-primary w-140px h-140px d-flex align-items-center justify-content-center'>
                                                        <KTIcon iconName={process.icon || 'element-11'} className='fs-3x text-primary' />
                                                    </div>
                                                )}
                                            </div>
                                            <h4 className='fs-3 fw-bolder text-dark mb-0'>{process.name}</h4>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        {processes.filter(p => p.processType === activeTab).length === 0 && (
                            <div className='col-12 text-center text-dark fs-4 py-20'>
                                No processes found for this category.
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export { ProcessCards }
